<div class="card season-tab-nav" fxLayoutAlign="start center" #seasonBar>
  <div class="season-tab-item-container" fxLayoutGap="30px">
      <span class="season-tab-item" *ngFor="let season of allSeasons"
            (click)="loadSelectedSeason(season, $event)"
            [class.active]="currentSeason.id === season.id">
        {{season.isClosed ? 'Abgeschlossene Saison' : 'Kommende Saison' }} ({{season.startYear}} / {{season.endYear}})
      </span>
  </div>
</div>
